import React from "react";
import { WorkflowObjectType } from "../../models";
import { Grid, Typography } from "@mui/material";
import { Trans } from "@lingui/macro";

interface PlaceholdersProps {
    templateType: WorkflowObjectType
    template?: boolean
}

interface PlaceholdersState {

}

export class Placeholders extends React.Component<PlaceholdersProps, PlaceholdersState> {
    render() {
        return (
            <>
                <Grid item xs={this.props.template ? 6 : 4}>
                    {
                        this.props.templateType === WorkflowObjectType.ASSET &&
                        <>
                            <Typography sx={{ backgroundColor: "primary.main", borderRadius: "3px", color: "background.default", ml: 2, mb: 2 }} textAlign={"center"}>
                                <Trans id={"new-template.placeholders.asset"}>
                                    Immobile
                                </Trans>
                            </Typography>
                            <Typography sx={{ ml: 2 }}>
                                <Trans id={"new-template.placeholders.asset.body"}>
                                    Indirizzo immobile: <b>{"{" + "asset_address" + "}"}</b><br />
                                    Descrizione: <b>{"{" + "asset_description" + "}"}</b><br />
                                    Proprietario: <b>{"{" + "asset_landlord" + "}"}</b>
                                </Trans>
                            </Typography>
                        </>

                    }
                    {
                        this.props.templateType === WorkflowObjectType.MATCH &&
                        <>
                            <Typography sx={{ backgroundColor: "primary.main", borderRadius: "3px", color: "background.default", ml: 2, mb: 2 }} textAlign={"center"}>
                                <Trans id={"new-template.placeholders.match"}>
                                    Match
                                </Trans>
                            </Typography>
                            <Typography sx={{ ml: 2 }}>
                                <Trans id={"new-template.placeholders.match.body"}>
                                    Indirizzo immmobile: <b>{"{" + "match_asset_address" + "}"}</b><br />
                                    Nome brand: <b>{"{" + "match_brand_name" + "}"}</b><br />
                                    Compatibilità: <b>{"{" + "match_compatibility" + "}"}</b>
                                </Trans>
                            </Typography>
                        </>
                    }
                    {
                        this.props.templateType === WorkflowObjectType.CONTRACT &&
                        <>
                            <Typography sx={{ backgroundColor: "primary.main", borderRadius: "3px", color: "background.default", ml: 2, mb: 2 }} textAlign={"center"}>
                                <Trans id={"new-template.placeholders.contract"}>
                                    Contratto
                                </Trans>
                            </Typography>
                            <Typography sx={{ ml: 2 }}>
                                <Trans id={"new-template.placeholders.contract.body"}>
                                    Numero contratto: <b>{"{" + "contract_contractNumber" + "}"}</b><br />
                                    Data di firma: <b>{"{" + "contract_signDate" + "}"}</b><br />
                                    Data di inizio: <b>{"{" + "contract_startDate" + "}"}</b><br />
                                    Data di fine: <b>{"{" + "contract_endDate" + "}"}</b><br />
                                    Nome brand: <b>{"{" + "contract_brand_name" + "}"}</b><br />
                                    Indirizzo immobile: <b>{"{" + "contract_asset_address" + "}"}</b><br />
                                    Proprietario: <b>{"{" + "contract_asset_landlord" + "}"}</b>
                                </Trans>
                            </Typography>
                        </>
                    }
                    {
                        this.props.templateType === WorkflowObjectType.GENERIC &&
                        <>
                            <Typography sx={{ backgroundColor: "primary.main", borderRadius: "3px", color: "background.default", ml: 2, mb: 2 }} textAlign={"center"}>
                                <Trans id={"new-template.placeholders.generic"}>
                                    Generico
                                </Trans>
                            </Typography>
                            <Typography sx={{ ml: 2 }}>
                                <Trans id={"new-template.placeholders.not-found"}>
                                    Non esistono placeholder per il tipo di template selezionato.
                                </Trans>
                            </Typography>
                        </>

                    }
                </Grid>
            </>
        )
    }
}
